var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopyIcon = function SvgCopyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85645 0.843945C2.85645 0.402118 3.21462 0.0439453 3.65645 0.0439453H11.1564C11.5983 0.0439453 11.9564 0.402118 11.9564 0.843945V8.34395C11.9564 8.78577 11.5983 9.14395 11.1564 9.14395H8.34395C7.90212 9.14395 7.54395 8.78577 7.54395 8.34395C7.54395 7.90212 7.90212 7.54395 8.34395 7.54395H10.3564V1.64395H4.45645V3.65645C4.45645 4.09827 4.09827 4.45645 3.65645 4.45645C3.21462 4.45645 2.85645 4.09827 2.85645 3.65645V0.843945Z",
    fill: "#646EC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0439453 3.65645C0.0439453 3.21462 0.402118 2.85645 0.843945 2.85645H8.34395C8.78577 2.85645 9.14395 3.21462 9.14395 3.65645V11.1564C9.14395 11.5983 8.78577 11.9564 8.34395 11.9564H0.843945C0.402118 11.9564 0.0439453 11.5983 0.0439453 11.1564V3.65645ZM1.64395 4.45645V10.3564H7.54395V4.45645H1.64395Z",
    fill: "#646EC8"
  })));
};
export default SvgCopyIcon;